import Image from 'mui-image';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import './ImageComponent.scss';

function ImageComponent({
  className,
  src,
  duration = 3000,
  easing = "cubic-bezier(0.7, 0, 0.6, 1)",
  showLoading,
  showErrorIcon = true,
  bgColor,
  shift = "right",
  shiftDistance = "100px",
  shiftDuration = 900,
  placeholder
}) {

  function getPlaceHolderIcon () {
    if (placeholder === 'profile-img') {
      return <AccountCircleIcon/>;
    }
  }

  const placeholderIcon = getPlaceHolderIcon();

  return (
    <div className={`image ${className || ''}`}>
      {src ? (
        <Image
          src={src}
          duration={duration}
          easing={easing}
          showLoading={showLoading}
          errorIcon={showErrorIcon}
          shift={shift}
          distance={shiftDistance}
          shiftDuration={shiftDuration}
          bgColor={bgColor}
        />
      ) : (
        <div className="image-placeholder">
          {placeholderIcon}
        </div>
      )}
    </div>
  );
}

export default ImageComponent;